<nav class="breadcrumb-trail" aria-label="Breadcrumb">
  <ol class="breadcrumb-trail-list" role="list">
    @for (crumb of trail(); track crumb.name) {
      <li class="breadcrumb-trail-item">
        @if (crumb.isCurrent || !crumb.path) {
          <span aria-current="page">{{ crumb.name }}</span>
        } @else {
          <a
            class="groove-text-link groove-ring breadcrumb-trail-link-shell"
            data-tone="accent"
            [routerLink]="crumb.path"
            [state]="{ restoreScroll: true }"
          >
            {{ crumb.name }}
          </a>
        }
      </li>
    }
  </ol>
</nav>
